import React, { useContext, useState,useEffect } from "react";
import SystemContext from "../../../AppState/SystemConfig/appContext";
import CircularProgress from "@mui/material/CircularProgress";


function RetrievePass(props) {
  /* Forgot props*/
  /* closeForgot: funcion que cambia el estado del variable del login a false */
  const { AppManager } = useContext(SystemContext);
  const [email, setEmail] = useState("");
  const [labelError , setLabelError] = useState("");
  const [labelError2 , setLabelError2] = useState("");
  const [loading, setloading] = useState(false);
  const [error, seterror] = useState(false);
  const [error2] = useState(false);

  const passwordSendedStatus = (response) => {
    setloading(false);
    if (response) {
      seterror(false);
      props.openConfirmRet();
    }else{
      seterror(true)
      // seterror2(true)
    }
  };
  prompt.passwordSendedStatus = passwordSendedStatus;

  const sendCorreo = () => {
    if (email !== "" && email.length > 7) {
      setloading(true);
      AppManager.forgotPassword(prompt, email);
    } else {
      
      if(!error){
        seterror(true);
        setTimeout(() => {
          seterror(false);
        }, 3000);
      }
      
    }
  };

  const onChangeInput = (event) => {
    setEmail(event.target.value);
  };
  useEffect(() => {

    if(AppManager.translator.current_lang==="es"){
      setLabelError("*Ingrese un correo electrónico valido")
      setLabelError2("*Error al enviar el correo electrónico, intente de nuevo mas tarde")
    }else{
      setLabelError2("*Error sending the email, try again later")
    }
  },[ error, error2, email, loading,AppManager.translator.current_lang]);

  return (
    <form>
      <h3 data-language_txt="txt_TitleRetry">¿No puedes iniciar sesión?</h3>
      <div className="mb-3">
        <label className="form-label" htmlFor="card-username" data-language_lbl="lbl_titleSendLink">
          Capture su correo electrónico para enviar un enlace:
        </label>
        <input className="form-control" id="card-email" type="email" value={email} onChange={onChangeInput} />
        <div style={{ display: "flex", flexDirection: "column", marginTop: "5px" }}>
          {error ? (
            <span style={{ color: "red", fontWeight: "700", fontSize: "13px" }} data-language_lbl="lbl_errorForgotEmail">
              {labelError}
            </span>
          ) : (
            <></>
          )}
          {error2 ? (
            <span style={{ color: "red", fontWeight: "700", fontSize: "13px" }} data-language_lbl="lbl_errorForgotEmail2">
              {labelError2}
            </span>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="mb-3" style={{ cursor: "pointer" }}>
        <button
          data-language_btn="btn_SendLink"
          className="id-btn d-block w-100 mt-3"
          type="button"
          style={{ height: "35px" }}
          onClick={sendCorreo}
        >
          Enviar enlace de recuperación{loading ? <CircularProgress size={20} style={{ marginLeft: 15 }}></CircularProgress> : <></>}
        </button>
      </div>
      <a
      href="#!"
        style={{ cursor: "pointer" }}
        className="col-auto id-link-basic"
        onClick={() => {
          props.backForgot();
          AppManager.changeLanguaje(AppManager.translator.current_lang);
        }}
      >
        <span data-language_txt="txt_BackRetry" className="fs--1">
          Regresar a inicio de sesión
        </span>
      </a>
    </form>
  );
}

export default RetrievePass;
